import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { getContext } from 'svelte';

var root = $.from_html(`<button type="button" class="w-full px-2 py-1.5 text-left text-sm rounded hover:bg-accent cursor-pointer"><!></button>`);

export default function Select_item($$anchor, $$props) {
	$.push($$props, true);

	const select = getContext('select');

	function handleClick() {
		// Use explicit label prop, otherwise try to extract from children, fallback to value
		const displayLabel = $$props.label || (typeof $$props.children === 'string' ? $$props.children : $$props.value);

		select.select($$props.value, displayLabel);
	}

	var button = root();

	button.__click = handleClick;

	var node = $.child(button);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(button);
	$.append($$anchor, button);
	$.pop();
}

$.delegate(['click']);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsic2VsZWN0LWl0ZW0uc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG4gIGltcG9ydCB7IGdldENvbnRleHQgfSBmcm9tICdzdmVsdGUnO1xuXG4gIGxldCB7XG4gICAgdmFsdWUsXG4gICAgbGFiZWwsXG4gICAgY2hpbGRyZW4sXG4gIH06IHtcbiAgICB2YWx1ZTogc3RyaW5nO1xuICAgIGxhYmVsPzogc3RyaW5nO1xuICAgIGNoaWxkcmVuPzogYW55O1xuICB9ID0gJHByb3BzKCk7XG5cbiAgY29uc3Qgc2VsZWN0ID0gZ2V0Q29udGV4dDx7XG4gICAgc2VsZWN0OiAodmFsdWU6IHN0cmluZywgbGFiZWw6IHN0cmluZykgPT4gdm9pZDtcbiAgfT4oJ3NlbGVjdCcpO1xuXG4gIGZ1bmN0aW9uIGhhbmRsZUNsaWNrKCkge1xuICAgIC8vIFVzZSBleHBsaWNpdCBsYWJlbCBwcm9wLCBvdGhlcndpc2UgdHJ5IHRvIGV4dHJhY3QgZnJvbSBjaGlsZHJlbiwgZmFsbGJhY2sgdG8gdmFsdWVcbiAgICBjb25zdCBkaXNwbGF5TGFiZWwgPSBsYWJlbCB8fCAodHlwZW9mIGNoaWxkcmVuID09PSAnc3RyaW5nJyA/IGNoaWxkcmVuIDogdmFsdWUpO1xuICAgIHNlbGVjdC5zZWxlY3QodmFsdWUsIGRpc3BsYXlMYWJlbCk7XG4gIH1cbjwvc2NyaXB0PlxuXG48YnV0dG9uXG4gIHR5cGU9XCJidXR0b25cIlxuICBvbmNsaWNrPXtoYW5kbGVDbGlja31cbiAgY2xhc3M9XCJ3LWZ1bGwgcHgtMiBweS0xLjUgdGV4dC1sZWZ0IHRleHQtc20gcm91bmRlZCBob3ZlcjpiZy1hY2NlbnQgY3Vyc29yLXBvaW50ZXJcIlxuPlxuICB7QHJlbmRlciBjaGlsZHJlbj8uKCl9XG48L2J1dHRvbj5cbiJdLCJtYXBwaW5ncyI6Ijs7U0FDVyxVQUFVLFFBQVEsUUFBUTs7Ozt1REFEckMsQ0FBQzs7O09BYU8sTUFBTSxHQUFHLFVBQVUsQ0FFdEIsUUFBUTs7VUFFRixXQUFXLEdBQUcsQ0FBQzs7UUFFaEIsWUFBWSxpREFBaUMsUUFBUTs7RUFDM0QsTUFBTSxDQUFDLE1BQU0sZ0JBQVEsWUFBWTtDQUNuQyxDQUFDOzs7O2tCQUtRLFdBQVc7Ozs7Ozs7O0FBSnZCLENBQUM7OyJ9